window.addEventListener('DOMContentLoaded', function() {
    swipercustom()
    $('.show-more-custom').on('click', function(){
      if($(".search_top1_ul_custom_pc_show_more").is(":visible")) {
        // 如果search_top1_ul_custom_pc_show_more已经显示，就使用slideUp()方法缓慢将其隐藏
        
        $('.show-more-span-custom').text('Show More')
        $('.show-less-icon-custom').css('display','none')
        $('.show-more-icon-custom').css('display','block')
        $(".search_top1_ul_custom_pc_show_more").slideUp(500);
        
      } else {
        // 否则，就使用slideDown()方法缓慢将其展开
        $('.show-more-span-custom').text('Show Less')
        $('.show-less-icon-custom').css('display','block')
        $('.show-more-icon-custom').css('display','none')
        $(".search_top1_ul_custom_pc_show_more").slideDown(500);
      }
    })
    $('.show-more-custom-search').on('click', function(){
      if($(".search_top1_ul_custom_pc_show_more_search").is(":visible")) {
        $('.show-more-span-custom-search').text('Show More')
        $('.show-less-icon-custom-search').css('display','none')
        $('.show-more-icon-custom-search').css('display','block')
        $(".search_top1_ul_custom_pc_show_more_search").slideUp(500);
      } else {
        $('.show-more-span-custom-search').text('Show Less')
        $('.show-less-icon-custom-search').css('display','block')
        $('.show-more-icon-custom-search').css('display','none')
        $(".search_top1_ul_custom_pc_show_more_search").slideDown(500);
      }
    })
  
    $("body").on("click",".my-select-collection-custom .selected-value-collection-custom", function(e){
        if($(this).closest(".my-select-collection-custom").find(".options-collection-custom").hasClass('hidden-collection-custom')){
          $(this).closest(".my-select-collection-custom").find(".options-collection-custom").removeClass('hidden-collection-custom')
          $(this).parents('.my-select-collection-custom ').siblings().find('.options-collection-custom').addClass("hidden-collection-custom")
        }else{
          $(this).closest(".my-select-collection-custom").find(".options-collection-custom").addClass('hidden-collection-custom')
        }
    });
  
    
    $(document).on("click", function(event) {
      if (!$(event.target).hasClass("options-collection-custom") && !$(event.target).hasClass("selected-value-collection-custom")) {
        $(".options-collection-custom:not(.hidden-collection-custom)").addClass("hidden-collection-custom");
      }
      event.stopPropagation();
    });

  
    $("body").on("click",".my-select-collection-custom .options-collection-custom li", function(e){
        var selectedValue = $(this).data('name');
        $(this).parent().addClass("hidden-collection-custom");
        $(this).closest(".my-select-collection-custom").find(".selected-value-collection-custom").text(selectedValue);
        var selecteddatavalue = $(this).data('value')
        $(this).parent().prev().children('span').attr("data-value", selecteddatavalue);
        var selecteddatatag = $(this).data('tag')
        $(this).parent().prev().children('span').attr("data-tag", selecteddatatag);
        var selecteddataname = $(this).data('name')
        $(this).parent().prev().children('span').attr("data-name", selecteddataname);
        quickFilter.init()
        
    });

  
    var isTypeurls = window.location.href;//判断是否是详情页
    changeUrlCustom(isTypeurls)
      if(isTypeurls.indexOf('cart')!=-1){
        var heightnote=$("#note").offset().top-20
      $('.wen-div-css').css({'top':heightnote})
      }
      if($(window).width() > 820){
        
        $('.wen-svg-mouseenter').on({
          mouseover : function(){$(this).parents('label').next().stop(true, true).slideToggle()} ,
          mouseout : function(){$(this).parents('label').next().stop(true, false).slideToggle()}
        }) ;
      }else{
          $('body').on("click", '.wen-svg-mouseenter', function (e) {
          if($(window).width() <= 820){
             $(this).parents('label').next().stop(true, true).slideToggle();
           }}); 
        }
    
    // if(isTypeurls.indexOf('search')!=-1){
    //   console.log(111)
    //   var q = GetQueryString("q")
    //   if(q != '' && q != null){
    //       q = q.replace(/\+/g,'');
    //       if (q.charAt(q.length-1) === "*") {
    //         q = q.substring(0, q.length-1);
    //       }
    //       var productrecenttype = false;
    //       var keywordlist = getKeyword()
    //       var linklist = getLink()
    //       var productindex = '';
            
    //       keywordlist.forEach(function (value, index) {
           
    //          if(existOneIncludeTwo(value,q)){
    //            productrecenttype = true;
    //            productindex = index
    //          }
    //       });
    //       console.log(productrecenttype)
    //       var product = linklist[productindex]
        
    //       if(productrecenttype){
    //         var productrecent = '';
    //         var evenold = ''
    //            for(var i=0;i<product.length;i++){
    //             if($(window).width() > 798){
    //               productrecent = productrecent+'<div class="four column alpha thumbnail">'+
    //                '<div class="product-wrap"> <div class="relative product_image swap-true">'+ 
    //                "<a href="+product[i].url+" marked='1' itemprop='url'>"+
    //                '<div class="image__container" style=" max-width:1001px; ">'+ 
    //                "<img class='lazyload' data-mainimageratio='1.0' alt="+product[i].name+" data-srcset="+product[i].img1+'_360x'+product[i].img1type+' 360w'+','+product[i].img1+'_540x'+product[i].img1type+' 540w'+','+product[i].img1+'_720x'+product[i].img1type+' 720w'+','+product[i].img1+'_900x'+product[i].img1type+' 900w'+" srcset="+product[i].img1+'_360x'+product[i].img1type+' 360w'+','+product[i].img1+'_540x'+product[i].img1type+' 540w'+','+product[i].img1+'_720x'+product[i].img1type+' 720w'+','+product[i].img1+'_900x'+product[i].img1type+' 900w'+">"+
    //                '</div> <div class="image__container" style="max-width: 1001px; ">'+ 
    //                "<img class='secondary lazyloaded' data-srcset="+product[i].img2+'_360x'+product[i].img2type+' 360w'+','+product[i].img2+'_540x'+product[i].img2type+' 540w'+','+product[i].img2+'_720x'+product[i].img2type+' 720w'+','+product[i].img2+'_900x'+product[i].img2type+' 900w'+" srcset="+product[i].img2+'_360x'+product[i].img2type+' 360w'+','+product[i].img2+'_540x'+product[i].img2type+' 540w'+','+product[i].img2+'_720x'+product[i].img2type+' 720w'+','+product[i].img2+'_900x'+product[i].img2type+' 900w'+" alt="+product[i].name+" >"+
    //                '</div></a>'+
    //                '<div class="thumbnail-overlay">'+ 
    //                "<a href="+product[i].url+" itemprop='url' class='hidden-product-link' marked='1'>"+product[i].name+"</a>"+
    //                "<div class='info'> <div class='product-details'> <span class='title' itemprop='name'>"+product[i].name+"</span>"+
    //                '</div></div>'+
    //                '</div>'+
    //                '</div> </div>'+
    //                '</div>'    
    //             }else{
    //               evenold = i % 2 ? 'odd' : 'even';
    //               productrecent = productrecent+"<div class='one-third column alpha thumbnail "+evenold+"'>"+
    //                 '<div class="product-wrap"> <div class="relative product_image swap-true">'+
    //                 "<a href="+product[i].url+" marked='1' itemprop='url'>"+
    //                 '<div class="image__container" style=" max-width:1001px; ">'+
    //                 "<img class='lazyload' data-mainimageratio='1.0' alt="+product[i].name+" data-srcset="+product[i].img1+'_360x'+product[i].img1type+' 360w'+','+product[i].img1+'_540x'+product[i].img1type+' 540w'+','+product[i].img1+'_720x'+product[i].img1type+' 720w'+','+product[i].img1+'_900x'+product[i].img1type+' 900w'+" srcset="+product[i].img1+'_360x'+product[i].img1type+' 360w'+','+product[i].img1+'_540x'+product[i].img1type+' 540w'+','+product[i].img1+'_720x'+product[i].img1type+' 720w'+','+product[i].img1+'_900x'+product[i].img1type+' 900w'+">"+
    //                 '</div> <div class="image__container" style="max-width: 1001px; "> '+
    //                 "<img class='secondary lazyloaded' data-srcset="+product[i].img2+'_360x'+product[i].img2type+' 360w'+','+product[i].img2+'_540x'+product[i].img2type+' 540w'+','+product[i].img2+'_720x'+product[i].img2type+' 720w'+','+product[i].img2+'_900x'+product[i].img2type+' 900w'+" srcset="+product[i].img2+'_360x'+product[i].img2type+' 360w'+','+product[i].img2+'_540x'+product[i].img2type+' 540w'+','+product[i].img2+'_720x'+product[i].img2type+' 720w'+','+product[i].img2+'_900x'+product[i].img2type+' 900w'+" alt="+product[i].name+" >"+
    //                 '</div></a>'+
    //                 '<div class="thumbnail-overlay">'+
    //                 "<a href="+product[i].url+" itemprop='url' class='hidden-product-link' marked='1'>"+product[i].name+"</a>"+
    //                 '<div class="info"> <div class="product-details">'+ 
    //                 "<span class='title' itemprop='name'>"+product[i].name+"</span>"+
    //                 '</div></div>'+
    //                 '</div></div>'+
    //                 "<a href="+product[i].url+" itemprop='url' class='product-info__caption hidden' marked='1'>"+
    //                 '<div class="product-details">'+ 
    //                 "<span class='title' itemprop='name'>"+product[i].name+"</span>"+
    //                 '</div>'+
    //                 '</a>'+
    //                 '</div></div>'
                      
    //             }
                 
    //           }
    //         if(productrecent !=''){
    //                productrecent = '<div class="sixteen columns wwh"><div itemtype="http://schema.org/ItemList" class="product-list search-matrix clearfix">'+productrecent+'</div></div>'
    //                $('.search_page_top1_custom').css({
    //                 'display':'none'
    //               })
    //               $('.tt-product-listing-search-custom').html(productrecent)
    //         }
             
            
    //       }
          
    //     }
    //   }
    if(isTypeurls.indexOf('search')!=-1){
      var q = GetQueryString("q")
      if(q != '' && q != null){
          q = q.replace(/\+/g,'');
          if (q.charAt(q.length-1) === "*") {
            q = q.substring(0, q.length-1);
          }
          var productrecenttype = false;
          var keywordlist = getKeyword()
          // var linklist = getLink()
          var productindex = '';
            var serachkeywordindex = keywordlist.findIndex(function(element) {
              return element.trim().toLowerCase() === q.trim().toLowerCase();
            });
            if (serachkeywordindex !== -1) {
              $('.search_keyword_custom_ajax_center').hide()
              $('.product-list.search-matrix.clearfix').css('display','none')
              $.ajax({
                url: 'https://www.fansdiy.info/index/index/getproductsearch',
                data: {
                    searchdata: q,
                },
                dataType:'json',
                type:'POST',
                success:function (res) {
                  if(res.searchlist !=''){
                    var newObj = res.searchlist;
                    $.each(newObj, function(key, value) {
                      var img = new Image();
                      img.onload = function() {
                      };
                    img.onerror = function() {
                      $('.search_keyword_custom_ajax_ul').find('li').eq(key).hide()
                    };
                      img.src = value.imgsrc;
                       productindex +='<li class="search_keyword_custom_ajax_li"><a style="color: black;-webkit-tap-highlight-color: transparent;  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);outline: none;" href="'+value.handle+'">'+
                        "<img src='"+value.imgsrc+"' style='width: 100%;'>"+
                        "<div>"+value.title+"</div>"+
                        "</a></li>"

                    });
                    productindexresult = '<div>Your search for "'+q+'" did not match any results. Please modify your search terms and try again.</div>'+'<h1 class="wwh" style="text-align:center;">You may like it</h1>'
                    productindex = productindexresult+"<ul class='search_keyword_custom_ajax_ul'>"+productindex+'</ul>'
                    $('.search_keyword_custom_ajax').html(productindex)
                  }
                }
              })
          }else{
               var addkeywordlist = getaddKeyword()
                var serachaddkeywordindex = addkeywordlist.findIndex(function(element) {
                  return element.trim().toLowerCase() === q.trim().toLowerCase();
                });
              if (serachaddkeywordindex !== -1) {
                $('.search_keyword_custom_ajax_center').hide()
                $.ajax({
                  url: 'https://www.fansdiy.info/index/index/getproductsearch',
                  data: {
                      searchdata: q,
                  },
                  dataType:'json',
                  type:'POST',
                  success:function (res) {
                    if(res.searchlist !=''){
                      var newObj = res.searchlist;
                      $.each(newObj, function(key, value) {
                        var img = new Image();
                        img.onload = function() {
                        };
                      img.onerror = function() {
                        $('.search_keyword_custom_ajax_ul').find('li').eq(key).hide()
                      };
                        img.src = value.imgsrc;
                         productindex +='<li class="search_keyword_custom_ajax_li"><a style="color: black;-webkit-tap-highlight-color: transparent;  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);outline: none;" href="'+value.handle+'">'+
                          "<img src='"+value.imgsrc+"' style='width: 100%;'>"+
                          "<div>"+value.title+"</div>"+
                          "</a></li>"
  
                      });
                      productindexresult = '<h1 class="wwh" style="text-align:center;">You may like it</h1>'
                      productindex = productindexresult+"<ul class='search_keyword_custom_ajax_ul'>"+productindex+'</ul>'
                      $('.product-list.search-matrix.clearfix').append(productindex)
                      
                    }
                  }
                })
              }
          }

          var pagekeywordlist = getPageKeyword()
          var serachpagekeywordindex = pagekeywordlist.findIndex(function(element) {
              return element.trim().toLowerCase() === q.trim().toLowerCase();
            });
          
          if (serachpagekeywordindex !== -1) {
            var serachpagekeywordindexhtml = ''
            serachpagekeywordindexhtml += '<h3 class="top-searches-search top-searches-search-mobile" style="text-align:initial">'+
                                          '<span style="color:black;">Blog</span>'+
                                          '</h3>'
            $.ajax({
              url: 'https://www.fansdiy.info/index/index/getpagesearch',
              data: {
                  searchdata: q,
              },
              dataType:'json',
              type:'POST',
              success:function (res) {
                if(res.searchlist !=''){
                  var newpageObj = res.searchlist;
                  $.each(newpageObj, function(pagekey, pagevalue) {
                     serachpagekeywordindexhtml +='<a href="'+pagevalue.url+'" target="_blank"><p>'+pagevalue.title+'</p></a>'

                  });
                  $('.search-custom-blog').html(serachpagekeywordindexhtml)
                  
                }
              }
            })
          }
          
          
          // keywordlist.forEach(function (value, index) {
           
          //    if(existOneIncludeTwo(value,q)){
          //      productrecenttype = true;
          //      productindex = index
          //    }
          // });
          // console.log(productrecenttype)
          // var product = linklist[productindex]
        
          // if(productrecenttype){
          //   var productrecent = '';
          //   var evenold = ''
          //      for(var i=0;i<product.length;i++){
          //       if($(window).width() > 798){
          //         productrecent = productrecent+'<div class="four column alpha thumbnail">'+
          //          '<div class="product-wrap"> <div class="relative product_image swap-true">'+ 
          //          "<a href="+product[i].url+" marked='1' itemprop='url'>"+
          //          '<div class="image__container" style=" max-width:1001px; ">'+ 
          //          "<img class='lazyload' data-mainimageratio='1.0' alt="+product[i].name+" data-srcset="+product[i].img1+'_360x'+product[i].img1type+' 360w'+','+product[i].img1+'_540x'+product[i].img1type+' 540w'+','+product[i].img1+'_720x'+product[i].img1type+' 720w'+','+product[i].img1+'_900x'+product[i].img1type+' 900w'+" srcset="+product[i].img1+'_360x'+product[i].img1type+' 360w'+','+product[i].img1+'_540x'+product[i].img1type+' 540w'+','+product[i].img1+'_720x'+product[i].img1type+' 720w'+','+product[i].img1+'_900x'+product[i].img1type+' 900w'+">"+
          //          '</div> <div class="image__container" style="max-width: 1001px; ">'+ 
          //          "<img class='secondary lazyloaded' data-srcset="+product[i].img2+'_360x'+product[i].img2type+' 360w'+','+product[i].img2+'_540x'+product[i].img2type+' 540w'+','+product[i].img2+'_720x'+product[i].img2type+' 720w'+','+product[i].img2+'_900x'+product[i].img2type+' 900w'+" srcset="+product[i].img2+'_360x'+product[i].img2type+' 360w'+','+product[i].img2+'_540x'+product[i].img2type+' 540w'+','+product[i].img2+'_720x'+product[i].img2type+' 720w'+','+product[i].img2+'_900x'+product[i].img2type+' 900w'+" alt="+product[i].name+" >"+
          //          '</div></a>'+
          //          '<div class="thumbnail-overlay">'+ 
          //          "<a href="+product[i].url+" itemprop='url' class='hidden-product-link' marked='1'>"+product[i].name+"</a>"+
          //          "<div class='info'> <div class='product-details'> <span class='title' itemprop='name'>"+product[i].name+"</span>"+
          //          '</div></div>'+
          //          '</div>'+
          //          '</div> </div>'+
          //          '</div>'    
          //       }else{
          //         evenold = i % 2 ? 'odd' : 'even';
          //         productrecent = productrecent+"<div class='one-third column alpha thumbnail "+evenold+"'>"+
          //           '<div class="product-wrap"> <div class="relative product_image swap-true">'+
          //           "<a href="+product[i].url+" marked='1' itemprop='url'>"+
          //           '<div class="image__container" style=" max-width:1001px; ">'+
          //           "<img class='lazyload' data-mainimageratio='1.0' alt="+product[i].name+" data-srcset="+product[i].img1+'_360x'+product[i].img1type+' 360w'+','+product[i].img1+'_540x'+product[i].img1type+' 540w'+','+product[i].img1+'_720x'+product[i].img1type+' 720w'+','+product[i].img1+'_900x'+product[i].img1type+' 900w'+" srcset="+product[i].img1+'_360x'+product[i].img1type+' 360w'+','+product[i].img1+'_540x'+product[i].img1type+' 540w'+','+product[i].img1+'_720x'+product[i].img1type+' 720w'+','+product[i].img1+'_900x'+product[i].img1type+' 900w'+">"+
          //           '</div> <div class="image__container" style="max-width: 1001px; "> '+
          //           "<img class='secondary lazyloaded' data-srcset="+product[i].img2+'_360x'+product[i].img2type+' 360w'+','+product[i].img2+'_540x'+product[i].img2type+' 540w'+','+product[i].img2+'_720x'+product[i].img2type+' 720w'+','+product[i].img2+'_900x'+product[i].img2type+' 900w'+" srcset="+product[i].img2+'_360x'+product[i].img2type+' 360w'+','+product[i].img2+'_540x'+product[i].img2type+' 540w'+','+product[i].img2+'_720x'+product[i].img2type+' 720w'+','+product[i].img2+'_900x'+product[i].img2type+' 900w'+" alt="+product[i].name+" >"+
          //           '</div></a>'+
          //           '<div class="thumbnail-overlay">'+
          //           "<a href="+product[i].url+" itemprop='url' class='hidden-product-link' marked='1'>"+product[i].name+"</a>"+
          //           '<div class="info"> <div class="product-details">'+ 
          //           "<span class='title' itemprop='name'>"+product[i].name+"</span>"+
          //           '</div></div>'+
          //           '</div></div>'+
          //           "<a href="+product[i].url+" itemprop='url' class='product-info__caption hidden' marked='1'>"+
          //           '<div class="product-details">'+ 
          //           "<span class='title' itemprop='name'>"+product[i].name+"</span>"+
          //           '</div>'+
          //           '</a>'+
          //           '</div></div>'
                      
          //       }
                 
          //     }
          //   if(productrecent !=''){
          //          productrecent = '<div class="sixteen columns wwh"><div itemtype="http://schema.org/ItemList" class="product-list search-matrix clearfix">'+productrecent+'</div></div>'
          //          $('.search_page_top1_custom').css({
          //           'display':'none'
          //         })
          //         $('.tt-product-listing-search-custom').html(productrecent)
          //   }
             
            
          // }
          
        }
      }
})


function swipercustom() {
    
    var htmlwidth = document.querySelector("html").offsetWidth;
      if(htmlwidth <= 768){
          var mySwiper = new Swiper ('#search-custom-page-design-trendingnow-pc,#search-custom-page-design-newarrival-pc,#search-custom-page-design-trendingnow-mobile,#search-custom-page-design-newarrival-mobile,#search-custom-page-design-search-trendingnow,#search-custom-page-design-search-newarrival', {
            direction: 'horizontal', // 垂直切换选项
            loop: true, // 循环模式选项
            slidesPerView: 2,
            spaceBetween:10,
            scrollbar: {
              el: '.swiper-scrollbar',
            },
            autoplayDisableOnInteraction : false,
            observer:true,
            observeParents:true,
          }) 
        
        }else{
          var mySwiper = new Swiper ('#search-custom-page-design-trendingnow-pc,#search-custom-page-design-newarrival-pc,#search-custom-page-design-trendingnow-mobile,#search-custom-page-design-newarrival-mobile,#search-custom-page-design-search-trendingnow,#search-custom-page-design-search-newarrival', {
            direction: 'horizontal', // 垂直切换选项
            loop: true, // 循环模式选项
            slidesPerView: 4,
            spaceBetween:15,
            // 如果需要前进后退按钮
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
          }) 
        }
}
function changeUrlCustom(isTypeurl) {

  // if(isTypeurl.indexOf('collections/all')!=-1){
  //   if(isTypeurl.indexOf('sort_by=created-ascending')!=-1 || isTypeurl.indexOf('sort_by=created-descending')!=-1){
  //     window.location.href="/collections/all?sort_by=best-selling";
  //   }
  // }
  
  if(isTypeurl.indexOf('my_custom_discount_shopify_my')!=-1){
    window.location.href="/cart";
  }

  if(isTypeurl.indexOf('my_custom_hoodie-hot-sale_my')!=-1){
    window.location.href="/collections/hoodie-hot-sale";
  }

  if(isTypeurl.indexOf('my_custom_butterfly-lovers-hoodie_my')!=-1){
    window.location.href="/collections/butterfly-lovers-hoodie";
  }
  if(isTypeurl.indexOf('my_custom_halloween_my')!=-1){
    window.location.href="/pages/halloween";
  }
  if(isTypeurl.indexOf('my_custom_family_month_my')!=-1){
    window.location.href="/collections/fansidea-family-month";
  }
  if(isTypeurl.indexOf('my_custom_3d_month_my')!=-1){
    window.location.href="/pages/3d-pattern";
  }
  if(isTypeurl.indexOf('my_custom_merry_christmas_my')!=-1){
    window.location.href="/pages/merry-christmas";
  }
  if(isTypeurl.indexOf('my_valentines_day_gifts_my')!=-1){
    window.location.href="/pages/valentines-day-gifts";
  }
  
}

function getaddKeyword(){
  var addkeyworddata = ["cowboy"]
  return addkeyworddata
}

function getKeyword() {
  var keyworddata = ["49ers", "49ers custom jersey", "49ers custom jerseys", "49ers jersey custom", "aqua dolphins jersey", "arsenal",
                     "astros", "atlanta", "atlanta braves", "atlanta braves baseball trikot", "atlanta braves jersey", "atlanta braves jersey baseball",
                     "barcelona", "baseballblack", "batman", "bears", "beige", "bengals", "bengals custom jersey", "billiards", "bills football jersey",
                     "bills stitched jersey", "bills throwback jersey", "bills white jersey", "black bills jersey", "black bulls jersey",
                     "black bulls jersey basketball", "black pittsburgh steelers jersey", "blood", "blue dolphins jersey", "blue jays", "braves",
                     "brewers", "broncos", "broncos custom jersey", "broncos jersey", "broncos uniforms", "browns custom jersey", "browns jersey",
                     "browns jersey custom", "browns uniforms", "bucket hat", "buffalo Bills", "buffalo bills blue jersey", "buffalo bills football jersey",
                     "buffalo bills football jerseys", "bulls", "bulls basketball jersey", "bulls custom jersey", "bulls jersey", "bulls jersey custom",
                     "bulls jersey custom name", "bulls jersey mens", "bulls jersey youth", "bulls jerseys", "burnt orange", "cannabis", "carolina blue",
                     "celtics", "chargers", "chicago", "chicago bears", "chicago bears custom infant jersey", "chicago bears custom jersey", "chicago bears custom jerseys",
                     "chicago bears custom throwback jersey", "chicago bears jersey custom", "chicago bulls", "chicago bulls custom jersey", "chicago bulls jersey custom",
                     "chicago cubs", "chiefs", "cincinnati", "cincinnati bengals", "cincinnati bengals custom jersey", "cincinnati bengals jersey custom",
                     "cincinnati reds", "cleveland browns custom jersey", "cleveland browns jersey custom", "cleveland browns uniforms", "colombia",
                     "columbia blue", "cornhole", "cowboys", "cowboys custom jersey", "cricket", "cricket jersey", "custom 49ers jersey",
                     "custom atlanta braves jersey", "custom bears jersey", "custom bengals jersey", "custom black 49ers jersey", "custom broncos jersey",
                     "custom browns jersey", "custom buckeyes jersey", "custom bulls jersey", "custom chicago bulls jersey", "custom cincinnati bengals jersey",
                     "custom cleveland browns jersey", "custom cowboys jersey", "custom cowboys jersey mens", "custom cowboys jersey womens", "custom dallas cowboys jersey",
                     "custom denver broncos jersey", "custom dodgers jersey", "custom dolphins jersey", "custom eagles jersey", "custom eagles throwback jersey",
                     "custom green seahawks jersey", "custom infant bears jersey", "custom infant dallas cowboys jersey", "custom infant steelers jersey",
                     "custom lakers jersey", "custom lakers jerseys", "custom made ohio state jersey", "custom miami dolphins jersey", "custom miami dolphins throwback jersey",
                     "custom ohio state buckeyes jersey", "custom ohio state football jersey", "custom ohio state jersey", "custom philadelphia eagles jersey",
                     "custom pittsburgh steelers jersey", "custom san francisco 49ers jersey", "custom seahawks jersey", "custom seattle seahawks jersey",
                     "custom steelers jersey", "custom steelers jersey mens", "custom toddler lakers jersey", "custom youth dallas cowboys jersey",
                     "custom youth steelers jersey", "customizable 49ers jersey", "customizable broncos jersey", "customizable cleveland browns jersey",
                     "customizable dallas cowboys jersey", "customizable ohio state football jersey", "customizable ohio state jersey", "customizable seahawks jersey",
                     "customizable steelers jersey", "Customize atlanta braves jersey", "customize browns jersey", "customize dallas cowboys jersey", 
                     "customize dodgers jersey", "customize lakers jersey", "customized broncos jersey", "customized browns jersey", "customized bulls jersey",
                     "customized cleveland browns jersey", "customized dallas cowboys jersey", "customized dolphins jersey", "customized eagles jersey",
                     "customized eagles jersey youth", "customized steelers jersey", "Dallas Cowboys", "dallas cowboys custom jersey", "dallas cowboys custom jersey mens",
                     "dallas cowboys custom jersey womens", "dallas cowboys custom jerseys", "dallas cowboys jerseys custom", "dallas cowboys personalized jersey",
                     "dallas cowboys youth customized jersey", "denver", "denver broncos custom jersey", "denver broncos jersey", "denver broncos throwback jersey",
                     "denver broncos throwback uniforms", "denver broncos uniforms", "denver nuggets", "detroit lions", "digital camo", "disc golf", "dodgers",
                     "dodgers baseball jersey", "dodgers custom jersey", "dodgers jersey", "dodgers jersey custom", "dodgers jersey kids", "dodgers jersey mens",
                     "dodgers jersey womens", "dodgers jersey youth", "dodgers personalized jersey", "dodgers trikot", "dolphins", "dolphins custom jersey",
                     "dolphins jersey", "dolphins jersey custom", "domin", "domini", "dominica", "dominican", "dominican republic", "eagle", "eagles",
                     "eagles custom jersey", "eagles uniforms", "f jersey", "florida", "florida gators", "foot jersey", "footb jersey", "goalie",
                     "goalie soccer", "gold lakers jersey", "gold lakers jersey basketball", "gold pittsburgh steelers jersey", "guatemala", "honduras",
                     "houston", "houston astros", "inter miami", "irish", "italian", "italy", "jaguar", "jersey philadelphia eagles", "jets", "kabbadi",
                     "kansas city", "kansas city chiefs", "knicks", "la dodgers jersey", "la dodgers trikot", "lacrosse", "lakers", "lakers basketball jersey",
                     "lakers custom jersey", "lakers jersey", "lakers jersey design", "lightning", "los angeles dodgers", "los angeles dodgers jersey",
                     "los angeles lakers", "majestic dodgers jersey", "make lakers jerseys", "manchester", "manchester united",  "mariners",
                     "men's custom 49ers jersey", "mens lakers jersey", "mets", "Miami Dolphins", "miami dolphins jersey", "miami dolphins jersey custom",
                     "miami dolphins jersey personalized", "miami dolphins personalized jersey", "miami dolphins shirt", "miami dolphins uniforms",
                     "miami heat", "miami hurricanes", "miami vice", "michigan", "minnesota", "mint", "mint green", "nba", "new orleans", "nrl",
                     "nuggets", "ohio", "ohio state", "ohio state baseball jersey", "ohio State Buckeyes", "ohio state buckeyes football", "ohio State Buckeyes jerseys",
                     "ohio state buckeyes mens", "ohio state buckeyes Scarlet jersey", "ohio state buckeyes womens", "ohio state custom football jersey",
                     "ohio state custom jersey", "ohio state customizable jersey", "ohio state football", "ohio state football jersey custom", 
                     "ohio state jersey custom", "ohio State jerseys", "ombre", "orange dolphins jersey", "orioles", "packers", "padres",
                     "penn state", "Personalized atlanta braves jersey", "personalized bengals jersey", "personalized black 49ers jersey",
                     "personalized bulls jersey", "personalized chicago bears jersey", "personalized dodgers jersey", "personalized seattle seahawks jersey",
                     "Philadelphia Eagles", "philadelphia eagles custom jersey", "philadelphia eagles jersey", "philadelphia eagles throwback jersey",
                     "philadelphia eagles uniforms", "phillies", "pirates", "pittsburgh steelers", "pittsburgh steelers custom jersey",
                     "pittsburgh steelers youth jerseys", "puerto", "puerto rico", "pull over", "purple lakers jersey", "purple lakers jersey basketball",
                     "raiders", "rangers", "raptors", "rasta", "ravens", "real madrid", "red bulls jersey", "red bulls jersey basketball",
                     "red sox", "retro", "reversable", "reversible", "reversible basketball", "reversible jersey", "ronaldo", "royal blue bills jersey", 
                     "rugby", "San Francisco 49ers", "san francisco 49ers custom jersey", "seahawks", "seahawks custom jersey", "seahawks jersey", 
                     "seahawks jersey custom", "seahawks throwback jersey", "seahawks uniforms", "seattle seahawks jersey", "seattle seahawks personalized jersey", 
                     "seattle seahawks uniforms", "snake skin", "soccer goalie", "sox", "spiderman", "spurs", "st louis", "steelers", "steelers custom jersey",
                     "steelers customizable jersey", "steelers jersey custom", "tank", "tank tops", "taylor swift", "texas", "texas rangers", "titans", "tops", 
                     "tribal", "turquoise", "united", "venezuela", "vikings", "weed", "white black bulls jersey", "white bulls jersey basketball", 
                     "white dodgers jersey", "white dolphins jersey", "white lakers jersey", "white lakers jersey basketball", "white sox", "windbreaker", 
                     "women's custom 49ers jersey", "yankee", "yankees", "youth lakers jersey"]
  return keyworddata;
}

function getPageKeyword() {
  var pagekeyworddata = ["mother's day gifts x breast cancer awareness", "Halloween party outfits", "remove wrinkles in custom jacket", "New Year",
                         "join Fansidea Softball Lover Facebook Group", "Customized Jackets", "Sororities", "neon baseball jersey", "hawaii baseball jersey",
                         "GameDay outfits", "custom sports jerseys printed with the picture of your pet", "custom summer camp uniform", "custom jersey for International Women's Day",
                         "custom jerseys about puppy", "autism apparel", "lgbt rainbow pride clothing", "jacket outfits idea", "make logo well on custom jacket",
                         "Football jerseys", "custom jersey for Valentine’s Day gift", "bloke core jersey", "homecoming apparel", "team jerseys", "LA Strong shirts",
                         "Christmas", "transgender jersey", "back to school jersey", "custom jerseys for St. Patrick’s Day gift", "custom basketball jerseys",
                         "graduate gifts", "pink jerseys", "thanksgiving gift", "Fix a Snap Button on Jackets", "basketball Jerseys", "Customized football jerseys",
                         "custom kids jersey", "leather jacket", "Patriotic Baseball Shirts", "polo collection", "bowling jerseys", "custom halloween jersey", "custom dart shirt",
                         "Custom Football Jersey", "Crossover jersey", "gradient jersey", "fashion casual jersey look", "Christmas gift for loved ones", "custom jersey tips",
                         "Baseball Jerseys", "custom army navy football jersey", "custom soccer jersey", "black month", "softball jersey", "throwback football jerseys",
                         "soccer jersey for all ages", "Thanksgiving", "Back to School Custom Jerseys", "custom bowling shirts", "fade fashion football",
                         "custom Chicano Style Baseball Jerseys", "custom floral print outfits", "black Friday deal", "customer feedback", "National Beer Day",
                         "Gender Reveal Baseball Party", "custom pink and blue baseball jerse", "custom jersey for celebrate graduation season", "theme jerseys",
                         "soccer jersey", "football jersey guide", "church apparel", "International Women’s Day", "custom UFO shirts", "custom jerseys", "tie dye jerseys",
                         "custom Chicano Baseball apparel", "Custom Beach Soccer jerseys", "New Year’s Day gift", "custom jersey at fansidea", "Esports jerseys",
                         "custom jersey for National Best Friends Day", "American flag custom jerseys and shorts", "3d print jersey", "father's day gifts", "breast cancer awareness",
                         "women's day shirts", "New Year's Eve", "custom jersey for music festival", "custom softball uniforms", "city edition", "custom skull fashion jerseys",
                         "olympics jerseys", "New Year’s Day jerseys", "customer feedback review", "Gym Training", "custom jersey for celebrate pride month",
                         "Taking care of the Earth with custom 3d pattern jerseys", "theme baseball jersey", "jersey fashion outfit", "western outfits", "custom big & tall jersey",
                         "Valentine's Day", "custom breast cancer jersey", "meaning of New Year’s Day", "Split Fashion", "3D Animal Patterned Custom Apparel", "Embroidery jerseys",
                         "pet dog clothing", "Halloween", "custom jersey for lesbian day", "Poker jerseys", "custom jersey for labor day gift", "custom sublimated jerseys",
                         "custom team jersey big logo", "holi festival outfit", "homecoming football", "choose right size of custom jersey", "Gender Reveal outfits",
                         "custom patriotic baseball jerseys", "sports and charity", "Cactus Pattern Shirts", "Fraternities", "Embroidery vs. screen printing jerseys", 
                         "Martin Luther King Jr. Day", "holiday outfits", "custom jersey for Easter", "custom kid's summer camp uniform", "custom purple jersey to take care of epilepsy",
                         "custom basketball jersey", "basketball jersey and shorts", "throwback baseball jersey", "Halloween guide", "steps of custom jerseys online", "Evil Eye",
                         "custom jerseys for mom's gift", "custom Greek jerseys for your fraternity or sorority", "custom group apparel", "micro print baseball jersey",
                         "flag jerseys and hoodie", "fishing", "custom Jerseys About Autism", "custom throwback jersey", "custom jersey to join Affiliate Community- photographers and vid",
                         "custom baseball jerseys", "hats", "pant", "team uniform", "pinstripe styles baseball jersey", "ribbon hues of apparel", "custom logo designs on sports jersey",
                         "Black History Month", "Customized Christmas gift jerseys", "custom jersey like Los Pepes Co do", "customization logo art", "football jerseys fashion",
                         "spring outfits", "theme park", "take care of breast cancer", "co-branded jersey", "Free Mocks Up Service for Custom Apparel", "custom baseball jerseys",
                         "baseball jersey", "abstract art jerseys", "Christmas outfits for family", "jersey size", "St. Patrick's Day", "Custom Football Jersey to celebrate Thanksgiving",
                         "custom hockey jersey", "Christmas Hockey Jerseys", "college basketball jersey", "gothic Baseball Shirts", "cancer ribbon on March and April",
                         "Hockey Jerseys", "custom beer jersey", "wear baseball jerseys", "color jersey", "custom big logo jerseys", "Custom Soccer Gear", "sports logo wear/ big logo",
                         "custom jacket tips", "Easter", "custom christmasl jersey", "custom team shirts", "New Year’s Day", "graduate gifts-t-shirt", "basketball jersey fashion",
                         "st.patrick's day", "Black Friday", "create your Video Game Day jersey", "custom sports apparel for kids", "beer's day", "custom patriotic jerseys",
                         "custom jerseys for family", "Cyber Monday", "Custom Embroidery jersey", "Soccer Jerseys", "custom jersey for celebrate National Coming Out Day",
                         "custom sports jerseys printed with the picture of your dog", "bowling shirts", "mother's day gifts", "baseball jerseys fashion", "Mardi Gras outfits",
                         "Hanukkah", "custom jersey to join Affiliate Community-wrestling", "custom hawaii basketball shorts", "pinstripe jersey", "custom veterans jerseys", 
                         "Custom Soccer Jerseys", "Kawanzza apparel", "customer feedback shipping", "Hawaiian", "custom jersey to join Affiliate Community-football", 
                         "custom jersey for runing", "girl power jerseys", "memorial day apparel", "hockey jerseys fashion", "gender reveal apparel", "Cat Lovers", 
                         "custom jersey for father day gift", "color jersey meaning black blue green purple red orange yellow", "Armed Forces Day", "custom 3d animal pattern jersey",
                         "rave outfit", "Mexican jerseys", "customization design apparel", "Extreme Sports", "join our Affiliate Partner Program", "custom basketball jersey",
                         "soccer uniforms for family sports day", "custom Easter outfits", "jersey fashion outfit: big flower+leopard", "western cowboy outfits",
                         "the benefit of Embroidery & Sublimation", "President's Day", "custom pride jerseys support for LGBT", "quotes about baseball jersey", "hawaii t-shirt",
                         "custom fraternity jersey", "graffiti outfits", "football team jersey", "camo jerseys", "custom jersey for Mother’s Day Gift", "Mardi Gras",
                         "wear custom jersey to Celebrate National Take a Walk in the Park", "cutom baseball jersey", "3d print abstract art baseball jersey"]
  return pagekeyworddata;
}

function getLink() {
  var producturllist = []
  return producturllist;
}

function existOneIncludeTwo(oneStr,twoStr) {
    return oneStr.map(function(x){ return x.toUpperCase() }).includes(twoStr.toUpperCase());
}

function getUrlParam(name) {
     var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
        var r = window.location.search.substr(1).match(reg);  //匹配目标参数
        if (r != null) return unescape(r[2]); return null; //返回参数值
}
function GetQueryString(name)
	{
		 var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
		 var r = window.location.search.substr(1).match(reg);
		 if(r!=null)return  unescape(r[2]); return null;
	}